import { Box } from '@mui/material';
import OfferIcon from '@/assets/offers/DiscountBadgeIcon';
import FlexBox from '@/atomic-components/FlexBox';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getStyle } from '@/utils/theme/fonts';
import { ApiState } from '@/models/generics';
import { CART_TYPE, TCartOffers } from '@/services/cart/models/cart';
import OffersListDrawer from '@/components/Offers/OffersListDrawer';
import { getColor } from '@/utils/theme/colors';
import { useCart } from '@/hooks/useCart';
import { useLogin } from '@/hooks/useLogin';
import OfferTile from './OfferTile';
import { IOffers } from '@/components/ProductDisplayPage/model';

import { SelectedOffer } from '@/components/Cart/VerticalCart';
import { useState } from 'react';
import OfferDrawerComponent from '@/components/ProductDisplayPage/Components/SideBar/Offers/offerDrawer';

const CartOffer = (props?: any) => {
	const { id: cartId, cartActions, rentCart, buyCart } = useCart();

	const [removeCouponApiState, setRemoveCouponApiState] = useState<ApiState>(
		ApiState.IDLE
	);
	const [enteredOfferCode, setEnteredOfferCode] = useState<string>('');
	const [isTermConditionsVisible, setIsTermConditionsVisible] =
		useState<boolean>(false);
	const { isLoggedIn, loginActions } = useLogin();
	const [applyOfferErrorMessage, setApplyOfferErrorMessage] =
		useState<string>();
	const OfferAppliedCart =
		props.cartType === CART_TYPE.RENT ? rentCart : buyCart;
	const [selectedOfferToView, setSelectedOfferToView] = useState<IOffers>();

	const [offerBeingApplied, setOfferBeingApplied] = useState<SelectedOffer>();
	const [offersListVisible, setOffersListVisible] = useState<boolean>(false);

	function onCodeInput(code: string) {
		setEnteredOfferCode(code);
		setApplyOfferErrorMessage('');
	}

	const cartOffers =
		props.cartType === CART_TYPE.RENT ? rentCart?.offers : buyCart?.offers;
	function closeOffersList() {
		setOffersListVisible(false);
	}
	function openOffersList() {
		if (!isLoggedIn) {
			loginActions.showLoginFlow();
			return;
		}

		setOffersListVisible(true);
	}

	const openTermConditions = () => {
		openOffersList();
	};

	const closeTermConditions = () => {
		closeOffersList();
	};
	const offerClicked = (offer: IOffers) => {
		setIsTermConditionsVisible(true);
		setSelectedOfferToView(offer);
	};
	function closeOfferDetails() {
		setSelectedOfferToView(undefined);
		setIsTermConditionsVisible(false);
	}

	const hasApplicableOffers =
		Array.isArray(props.offers?.applicableOffers) &&
		!!props.offers?.applicableOffers.length;

	const hasBankOffer =
		Array.isArray(props.offers?.bankOffers) &&
		!!props.offers?.bankOffers.length;

	const hasNonApplicableOffers =
		Array.isArray(props.offers?.nonApplicableOffers) &&
		!!props.offers?.nonApplicableOffers.length;
	const hasNcEmiOffer =
		Array.isArray(props.offers?.ncEmiOffer) &&
		!!props.offers?.ncEmiOffer.length;

	return (
		<>
			<Box>
				<FlexBox justifyContent='space-between'>
					<FlexBox alignItems='center' gap='8px'>
						<OfferIcon />
						<FlexBox direction='column'>
							<LencoTypography sx={{ ...getStyle('P_Medium') }}>
								{props.cartType === CART_TYPE.RENT ? 'Rental' : 'Buy'} Offers &
								Discounts
							</LencoTypography>
							<LencoTypography
								sx={{
									textDecoration: 'underline',
									cursor: 'pointer',
									...getStyle('Tiny_Regular'),
								}}
								onClick={openOffersList}
							>
								View all
							</LencoTypography>
						</FlexBox>
					</FlexBox>
					<LencoTypography
						sx={{
							textDecoration: 'underline',
							...getStyle('P_Medium'),
							cursor: 'pointer',
							color: getColor('Minty 0'),
						}}
						onClick={openOffersList}
					>
						Have a Coupon code?
					</LencoTypography>
				</FlexBox>
				<FlexBox
					mt='16px'
					gap='1rem'
					// justifyContent='center'
					alignItems='center'
					sx={{ flexWrap: 'no-wrap', overflowX: 'scroll' }}
				>
					{hasApplicableOffers &&
						props?.offers?.applicableOffers?.map((item: any, index: any) => (
							<OfferTile
								key={index}
								offerClicked={offerClicked}
								rentOffer={item}
								openOffersListDrawer={openOffersList}
								isTermConditionsVisible={isTermConditionsVisible}
								rentCart={OfferAppliedCart}
								applyOfferToCart={props?.applyOfferToCart}
								cartType={props.cartType}
								removingCouponCode={removeCouponApiState === ApiState.LOADING}
								onRemove={props?.onRemove}
								isApplied={
									OfferAppliedCart?.appliedCoupon?.appliedCouponId === item?.id
								}
							/>
						))}
					{hasBankOffer &&
						props?.offers?.bankOffers?.map((item: any, index: any) => (
							<OfferTile
								key={index}
								rentOffer={item}
								offerClicked={offerClicked}
								rentCart={OfferAppliedCart}
								applyOfferToCart={props?.applyOfferToCart}
								isTermConditionsVisible={isTermConditionsVisible}
								cartType={props.cartType}
								removingCouponCode={removeCouponApiState === ApiState.LOADING}
								onRemove={props?.onRemove}
								isApplied={
									OfferAppliedCart?.appliedCoupon?.appliedCouponId === item?.id
								}
							/>
						))}
					{hasNcEmiOffer &&
						props?.offers?.ncEmiOffer?.map((item: any, index: any) => (
							<OfferTile
								key={index}
								rentOffer={item}
								offerClicked={offerClicked}
								rentCart={OfferAppliedCart}
								applyOfferToCart={props?.applyOfferToCart}
								isTermConditionsVisible={isTermConditionsVisible}
								cartType={props.cartType}
								removingCouponCode={removeCouponApiState === ApiState.LOADING}
								onRemove={props?.onRemove}
								isApplied={
									OfferAppliedCart?.appliedCoupon?.appliedCouponId === item?.id
								}
							/>
						))}
					{hasNonApplicableOffers &&
						props?.offers?.nonApplicableOffers.map((item: any, index: any) => (
							<OfferTile
								key={index}
								rentOffer={item}
								offerClicked={offerClicked}
								isnonApplicableOffers={true}
								applyOfferToCart={props?.applyOfferToCart}
								isTermConditionsVisible={isTermConditionsVisible}
								cartType={props.cartType}
								removingCouponCode={removeCouponApiState === ApiState.LOADING}
								onRemove={props?.onRemove}
								isApplied={
									rentCart?.appliedCoupon?.appliedCouponId === item?.id
								}
							/>
						))}
				</FlexBox>
			</Box>
			<OffersListDrawer
				hasApplicableOffers={hasApplicableOffers}
				hasBankOffer={hasBankOffer}
				offerClicked={offerClicked}
				hasNonApplicableOffers={hasNonApplicableOffers}
				offers={cartOffers as TCartOffers}
				cart={props.cartType === CART_TYPE.RENT ? rentCart : buyCart}
				visible={offersListVisible}
				onClose={closeOffersList}
				closeTermConditions={closeTermConditions}
				isTermConditionsVisible={isTermConditionsVisible}
				openTermConditions={openTermConditions}
				applyOfferToCart={props?.applyOfferToCart}
				cartType={props.cartType}
				offerBeingApplied={offerBeingApplied}
				appliedOffer={props.verticalCart?.appliedCoupon}
				errorMessage={applyOfferErrorMessage}
				enteredOfferCode={enteredOfferCode}
				onCodeInput={onCodeInput}
				onRemove={props?.onRemove}
				removingCouponCode={removeCouponApiState === ApiState.LOADING}
			/>
			<OfferDrawerComponent
				offer={selectedOfferToView}
				open={!!selectedOfferToView}
				onClose={closeOfferDetails}
				isTermConditionsVisible={isTermConditionsVisible}
				OfferAppliedCart={OfferAppliedCart}
				cartType={props.cartType}
				applyOfferToCart={props?.applyOfferToCart}
				removingCouponCode={removeCouponApiState === ApiState.LOADING}
				onRemove={props?.onRemove}
				hasNonApplicableOffers={hasNonApplicableOffers}
				nonApplicableOffers={props?.offers?.nonApplicableOffers}
			/>
		</>
	);
};

export default CartOffer;
